import { FunctionBlockUiState } from '@/store/modules/functionBlockUi/types'
import { RootState } from '@/store/types'
import { ActionTree } from 'vuex'

export const actions: ActionTree<FunctionBlockUiState, RootState> = {
}
